<form [formGroup]="inputFieldForm">
  <div class="pointer-events-none">
    <finxone-input
      [type]="'text'"
      [name]="'payment-ref'"
      [formControlName]="inputFieldKey"
      [parentControl]="$any(inputFieldForm.get(inputFieldKey))"
      [label]="inputLabel ?? ''"
      [value]="inputValue"
      [maxLength]="maxLength"
      [infoText]="remainingChars"
      [validationConfig]="validationConfig"
      (change)="onChangeConfig()"
    >
    </finxone-input>
  </div>
</form>
